import { render, staticRenderFns } from "./CardDependente.vue?vue&type=template&id=7494994e&scoped=true&"
import script from "./CardDependente.vue?vue&type=script&lang=js&"
export * from "./CardDependente.vue?vue&type=script&lang=js&"
import style0 from "./CardDependente.vue?vue&type=style&index=0&id=7494994e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7494994e",
  null
  
)

export default component.exports